

export const getKey = () => {
  return import.meta.env.VITE_PASSPHRASE;
};
